import { render, staticRenderFns } from "./BusList.vue?vue&type=template&id=720e8f6e&scoped=true&"
import script from "./BusList.vue?vue&type=script&lang=js&"
export * from "./BusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720e8f6e",
  null
  
)

export default component.exports